export default __webpack_public_path__ + "static/media/banner_lima_bohemian.46f49f98.JPG";